import { DefaultService } from '@/services/DefaultService';

export default class VendasRelComparativoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    load (filtros) {
        return this._http.post(`${this._env}/report/chart/sales.json`, filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
        });

    }
    
}